export default "__VITE_PUBLIC_ASSET__7aabe423__"